import { useQuery } from '@tanstack/react-query'
import { api } from './api'

export interface EnvTempReading {
  ts: string
  temp_c: number | null
}

export interface EnvTempSensor {
  sensor_id: string
  inside: EnvTempReading | null
  outside: EnvTempReading | null
  delta_c: number | null
}

export interface EnvTempLatest {
  sensors: EnvTempSensor[]
}

export interface EnvTempSeries {
  range: string
  bucket_seconds: number
  points: { b: string; inside_c: number | null; outside_c: number | null }[]
}

export function useEnvTemp() {
  return useQuery<EnvTempLatest>({
    queryKey: ['env-temp'],
    queryFn: () => api<EnvTempLatest>('/api/metrics/env-temp'),
    refetchInterval: 30_000,
  })
}

export function useEnvTempSeries(range = '24h') {
  return useQuery<EnvTempSeries>({
    queryKey: ['env-temp-series', range],
    queryFn: () => api<EnvTempSeries>(`/api/metrics/env-temp/series?range=${range}`),
    refetchInterval: 60_000,
  })
}

export function celsius(n: number | null | undefined): string {
  if (n == null) return '—'
  return `${n.toFixed(1)} °C`
}
